import { useContext } from 'react';
import { ArrecadacaoContext } from '../contexts/ArrecadacaoContext';
import { MessageStatus } from '@govbr-ds/react-components/dist/types/messages';
import { IArrecadacaoError } from 'interfaces/IArrecadacaoError';
import { incluirSentryIdMsgErro } from 'utils/incluirSentryIdMsgErro';

export const useNotificacao = () => {
  const context = useContext(ArrecadacaoContext);
  if (!context) {
    throw new Error('useNotificacao deve ser usado dentro de um ArrecadacaoProvider');
  }

  return ({
    conteudo,
    tipo,
    complementoSentryId,
  }: {
    conteudo: string;
    tipo: MessageStatus;
    complementoSentryId?: IArrecadacaoError | null | undefined;
  }) => {
    context.setMensagens([
      ...context.mensagens,
      {
        tipo: tipo,
        mensagem: conteudo + (complementoSentryId ? ` ${incluirSentryIdMsgErro(complementoSentryId)}` : ''),
      },
    ]);
  };
};
